export type Product = {
  id: number;
  name: string;
  price: number;
  image: string;
  category: string;
  active: boolean;
};

export const products: Product[] = [
  // ===== BIQUÍNIS =====
  {
    id: 1,
    name: "Biquíni Azul",
    price: 35.5,
    image: require("../assets/products/BiquiniAzul.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 2,
    name: "Biquíni Branco e Preto",
    price: 35.5,
    image: require("../assets/products/BiquiniBranco+Preto.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 28,
    name: "Biquíni Rosa",
    price: 35.5,
    image: require("../assets/products/BiquiniRosa.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 3,
    name: "Biquíni Shortinho",
    price: 35.5,
    image: require("../assets/products/BiquiniShortinho.png"),
    category: "Roupas de Banho",
    active: true,
  },

  // ===== BODY =====
  {
    id: 4,
    name: "Body/Maiô Verde",
    price: 35.0,
    image: require("../assets/products/BodyAzul-Verde.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 5,
    name: "Maiô Preto",
    price: 49.9,
    image: require("../assets/products/BodyPreto.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 18,
    name: "Maiô Preto",
    price: 49.9,
    image: require("../assets/products/BodyPretoLinha.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 19,
    name: "Maiô Roxo",
    price: 49.9,
    image: require("../assets/products/BodyRoxo.png"),
    category: "Roupas de Banho",
    active: true,
  },
  {
    id: 20,
    name: "Maiô Azul Claro",
    price: 49.9,
    image: require("../assets/products/BodyAzulClaro.png"),
    category: "Roupas de Banho",
    active: true,
  },

  // ===== CAMISAS =====
  {
    id: 6,
    name: "Camisa Ajax",
    price: 50.0,
    image: require("../assets/products/CamisaAjax.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 7,
    name: "Camisa Liverpool",
    price: 50.0,
    image: require("../assets/products/CamisaLiverpool.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 21,
    name: "Camisa Real Madrid",
    price: 50.0,
    image: require("../assets/products/CamisaRealMadrid.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 22,
    name: "Camisa Palmeiras Amarela",
    price: 50.0,
    image: require("../assets/products/CamisaPalmeirasAmarela.png"),
    category: "Roupas Esportivas",
    active: true,
  },
    {
    id: 23,
    name: "Camisa Botafogo PB",
    price: 50.0,
    image: require("../assets/products/CamisaBotafogoPB.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 24,
    name: "Camisa Borrussia Dortmund",
    price: 50.0,
    image: require("../assets/products/CamisaDortmund.png"),
    category: "Roupas Esportivas",
    active: true,
  },


  // ===== DRY FIT =====
  {
    id: 8,
    name: "Camisa Dry Fit Preta  - Feminina",
    price: 20.0,
    image: require("../assets/products/CamisaDrifitPreta.png"),
    category: "Roupas Esportivas",
    active: true,
  },
    {
    id: 25,
    name: "Camisa Dry Fit Branca - Feminina",
    price: 20.0,
    image: require("../assets/products/CamisaDrifitBranca.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 26,
    name: "Camisa Dry Fit Branca Extreme - Feminina",
    price: 20.0,
    image: require("../assets/products/CamisaDrifitExtremeBranca.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 27,
    name: "Camisa Dry Fit Marrom - Feminina",
    price: 20.0,
    image: require("../assets/products/CamisaDrifitMarrom.png"),
    category: "Roupas Esportivas",
    active: true,
  },
  {
    id: 28,
    name: "Conjunto Dry Fit Azul - Feminina",
    price: 50.0,
    image: require("../assets/products/ConjAcademiaAzul.png"),
    category: "Roupas Esportivas",
    active: true,
  },

  // ===== SHORTS =====
  {
    id: 9,
    name: "Short Refletivo Preto",
    price: 50.0,
    image: require("../assets/products/ShortRefletivoPreto (2).png"),
    category: "Shorts",
    active: true,
  },
  {    id: 14,
    name: "Short Refletivo Cinza",
    price: 50.0,
    image: require("../assets/products/ShortRefletivoCinza.png"),
    category: "Shorts",
    active: true,
  },
  {
    id: 15,
    name: "Short Refletivo Azul",
    price: 50.0,
    image: require("../assets/products/ShortRefletivoAzul+Preto.png"),
    category: "Shorts",
    active: true,
  },
  {
    id: 16,
    name: "Short Refletivo Preto",
    price: 50.0, 
    image: require("../assets/products/ShortRefletivoPreto (2).png"),
    category: "Shorts",
    active: true,
  },
  {
    id: 17,
    name: "Short Refletivo Vermelho",
    price: 50.0,
    image: require("../assets/products/ShortRefletivoVermelho.png"),
    category: "Shorts",
    active: true,
  },

  // ===== TÊNIS =====
  {
    id: 9,
    name: "Tênis Air Force 1 - Branco",
    price: 95.0,
    image: require("../assets/products/TenisAirForceBranco.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 29,
    name: "Tênis Air Force 1 - Branco e Rosa",
    price: 95.0,
    image: require("../assets/products/TenisAirForceBrancoeRosa.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 30,
    name: "Tênis Vans - Preto",
    price: 95.0,
    image: require("../assets/products/TenisVansPreto.png"),
    category: "Tênis",
    active: true,
  },
  
  {
    id: 10,
    name: "Tênis Nike Preto",
    price: 95.0,
    image: require("../assets/products/TenisNikePreto.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 11,
    name: "Tênis Nike Branco",
    price: 95.0,
    image: require("../assets/products/TenisNikeBranco.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 12,
    name: "Tênis Nike Cinza",
    price: 95.0,
    image: require("../assets/products/TenisNikeCinza.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 13,
    name: "Tênis olympikus rosa",
    price: 95.0,
    image: require("../assets/products/TenisOlympicosRosa.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 29,
    name: "Tênis olympikus preto",
    price: 95.0,
    image: require("../assets/products/TenisOlympicosPreto.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 30,
    name: "Tênis Mizuno Preto e Vermelho",
    price: 95.0,
    image: require("../assets/products/TenisMizunoSoladoBege.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 31,
    name: "Tênis Mizuno Preto",
    price: 95.0,
    image: require("../assets/products/TenisMizunoPreto.png"),
    category: "Tênis",
    active: true,
  },
  {
    id: 32,
    name: "Tênis Mizuno Branco",
    price: 95.0,
    image: require("../assets/products/TenisMizunoBranco.png"),
    category: "Tênis",
    active: true,
  },
  {    id: 33,
    name: "Tênis Mizuno Cinza e Vermelho",
    price: 95.0,
    image: require("../assets/products/TenisMizunoCinzaVermelho.png"),
    category: "Tênis",
    active: true,
  },

  // ===== CHUTEIRA =====
  {
    id: 34,
    name: "Chuteira Campo Umbro",
    price: 95.0,
    image: require("../assets/products/ChuteiraCampoUmbro.png"),
    category: "Chuteiras",
    active: true,
  },
  {
    id: 35,
      name: "Tênis Rainha Futsal - Branco",
    price: 110.0,
    image: require("../assets/products/TenisRainhaFutsalBranco.png"),
    category: "Chuteiras",
    active: true,
  },
  {
    id: 36,
    name: "Tênis Rainha Futsal - Azul Escuro",
    price: 110.0,
    image: require("../assets/products/TenisRainhaFutsalAzul.png"),
    category: "Chuteiras",
    active: true,
  },
];
